<section id="wrapper" class="error-page">
  <div>
      <div class="error-body text-center">
          <h1>403</h1>
          <h3 class="text-uppercase">ACCESO NO AUTORIZADO!</h3>
          <p class="text-muted m-t-30 m-b-30">NO TIENES ACCESO A ESTA SECCIÓN.</p>
          <a href="index.html" class="btn btn-info btn-rounded waves-effect waves-light m-b-40">Back to home</a> </div>
  </div>
</section>
